module.exports = __webpack_public_path__ + "img/comstu2.71e38ebb.jpeg";